import React from "react";

const MethodBadge = ({ method, size = "normal" }) => {
  const className = `api-docs-method api-docs-method--${method.toLowerCase()} ${
    size === "small" ? "api-docs-method--small" : ""
  }`;

  return <span className={className}>{method}</span>;
};

export default MethodBadge;
